import { ContactType } from '../app/constants/amoCRM';
import { apiMyLead } from '../app/constants/urls';
import { getAdvCakeCookie } from './advCake';
import {
  getRoistatFromCookie,
  getUtmFromCookie,
  getYmUidFromCookie,
  getGaUidFromCookie,
  YM_COUNTER_WEBSITE,
} from './utmCookie';

export async function sendLeadData(data, extraLeadData = {}) {
  const { advcake_track_id: advcakeId, advcake_track_url: advcakeUrl } =
    getAdvCakeCookie();

  const advcakeParams = {
    totalPrice: data.totalPrice || 0,
    promocode: data.promocode,
    advcakeId,
    advcakeUrl,
    advcakeLeadName: data.leadName || 'заявка',
  };
  const body = {
    ...data,
    howToContact: ContactType[data.howToContact] || 'Телефон',
    ...extraLeadData,
    ...advcakeParams,
  };

  return await fetch(apiMyLead, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
}

export function getSubmitFields(form) {
  let clientId = '';
  try {
    clientId = window?.ga?.getAll()[0].get('clientId');
  } catch (e) {}

  return {
    ...form,
    clientId,
    roistatVisit: getRoistatFromCookie(),
    targetPage: window.location.pathname,
    utm: getUtmFromCookie(),
    ym_uid: getYmUidFromCookie(),
    ga_uid: getGaUidFromCookie(),
    ym_counter: YM_COUNTER_WEBSITE,
  };
}
